import { createContext, useContext } from "react";
import { LinkedWorkpapersCache } from "../../../../hooks/useOptroLinkedWorkpapers";
import {
  OptroControlSummary,
  OptroWorkpaperFile,
} from "../../../../models/audit/optroSync";

export interface OptroImportWizardValue {
  selected: OptroControlSummary[];
  toggleControl: (control: OptroControlSummary) => void;
  isSelected: (externalRef: string) => boolean;
  selectMany: (controls: OptroControlSummary[]) => void;
  clearSelection: () => void;
  workpaperDecisions: Record<string, OptroWorkpaperFile[]>;
  // `source` records WHO decided, which the decision itself cannot express:
  // an empty list means "no workpaper" whether the crawl seeded it or the
  // user cleared it. Only "user" adds the ref to `userEditedRefs`. Required
  // rather than defaulted so a new call site has to say which it is.
  setWorkpapers: (
    externalRef: string,
    files: OptroWorkpaperFile[],
    source: "match" | "user",
  ) => void;
  // Refs the user has decided on themselves. Lives here rather than in the
  // review page's own state so it survives the page unmounting (Review ->
  // Select -> Review keeps this layout mounted, and `workpaperDecisions`
  // along with it, while the review page and its match job both restart).
  userEditedRefs: Set<string>;
  // Each control's Optro workpaper candidates for the Change Workpaper
  // dialog. Owned by the wizard so it lasts exactly as long as one import:
  // kept across Review -> Select -> Review, dropped when the wizard unmounts
  // (import started, navigated away, signed out).
  linkedWorkpapersCache: LinkedWorkpapersCache;
}

export const OptroImportWizardContext =
  createContext<OptroImportWizardValue | null>(null);

export function useOptroImportWizard(): OptroImportWizardValue {
  const value = useContext(OptroImportWizardContext);
  if (!value) {
    throw new Error(
      "useOptroImportWizard must be used within OptroImportWizardLayout",
    );
  }
  return value;
}
